// extracted by mini-css-extract-plugin
export var columnItem = "_co-3";
export var columnItemDraggable = "_co-5";
export var dragHandle = "_co-0";
export var dragHandleHovered = "_co-1";
export var dropdown = "_co-6";
export var dropdownContent = "_co-8";
export var dropdownInner = "_co-7";
export var filterDropdownHeader = "_co-9";
export var icon = "_co-2";
export var moveToTopButton = "_co-4";
export var sectionDivider = "_co-a";